import { render, staticRenderFns } from "./documentos.vue?vue&type=template&id=4f0b9bac&scoped=true&"
import script from "./documentos.vue?vue&type=script&lang=js&"
export * from "./documentos.vue?vue&type=script&lang=js&"
import style0 from "./documentos.vue?vue&type=style&index=0&id=4f0b9bac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b9bac",
  null
  
)

export default component.exports